import { useState,useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './auth/Login';
import Signup from './auth/Signup';
import ForgotPassword from './auth/ForgotPassword';
import CloverCallback from './auth/CloverCallback';
import CloverIntegration from './auth/CloverIntegration';
import OAuthCallback from './integrations/OAuthCallback';
import ProtectedRoute from './auth/ProtectedRoute';
import MainLayout from './layout';
import Dashboard from './dashboard';
import { Analytics } from './analytics';
import { CampaignIdeas } from './campaingIdeas';
import { Playground } from './playGround';
import { Integrations } from './integrations';
import { Demographics } from './demographics';
import { MenuEnhancement } from './menuEnhancement';
import { MarketingCalendar } from './marketingCampaign';
import ReviewAnalysis from './reviewAnalysis';
import CompetitorPromotions from './competitorPromotions';
import Competitors from './competitors';
import UpcomingEvents from './upcomingEvents';
import CampaignGenerator from './campaignGenerator';
import Campaigns from './campaigns';
import Menu from './menu';
import { GetStarted, Processing } from './launching';
import PostCampaign from './postCampaign';
import NotFound from './common/NotFound';
import { CampaignCreation } from './campaignCreation';
import { useLocalStorageSync } from '../hooks/useLocalStorageSync'
import { useRestaurantNav } from '../hooks/useRestaurantNav'
import { useCloverIntegration } from '../hooks/useCloverIntegration'
import GlobalLoaders from '../components/common/GlobalLoaders'
import { VOICE_AI_URL } from '../api/config'

const AppWrapper = () => {
    useLocalStorageSync();
    const { navigate } = useRestaurantNav();
    const { loading, showMenuLoader, status, cloverError, hasError  } = useCloverIntegration();
    const [displayLoader, setDisplayLoader] = useState(false);
  
    useEffect(() => {
      if (showMenuLoader) {
        setDisplayLoader(true);
      } else if (!showMenuLoader && displayLoader) {
        const timer = setTimeout(() => {
          setDisplayLoader(false);
          navigate("/generate");
        }, 2000);
  
        return () => clearTimeout(timer);
      }
    }, [showMenuLoader, displayLoader]);
  return (
    <>
      <GlobalLoaders
        integrationLoading={loading}
        menuLoading={displayLoader}
        menuStatus={status}
        cloverError={cloverError}
        hasError={hasError}
      />
        <Routes>
          {/* Root Route - Check authentication and redirect */}
          <Route path="/" element={
            (() => {
              const restaurantId = localStorage.getItem('restaurantId');
              const accountId = localStorage.getItem('account_id');
              const token = localStorage.getItem('token');
              const isAuthenticated = restaurantId && (accountId || token);
              
              if (!isAuthenticated) {
                // Redirect to Voice AI URL if not authenticated
                window.location.href = VOICE_AI_URL;
                return null;
              }
              
              // Redirect to dashboard if authenticated
              return <Navigate to={`/${restaurantId}/dashboard`} replace />;
            })()
          } />
          
          {/* Public Routes - No authentication required */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/integrate-clover" element={<CloverIntegration />} />
          <Route path="/clover/callback" element={<CloverCallback />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/:restaurantId/generate" element={<GetStarted />} />
          
          {/* All Protected Routes - Wrapped in single ProtectedRoute */}
          <Route element={<ProtectedRoute />}>
            {/* Protected Routes - No sidebar */}
            {/* <Route path="/:restaurantId/generate" element={<GetStarted />} /> */}
            <Route path="/:restaurantId/processing" element={<Processing />} />
            <Route path="/oops" element={<NotFound />} />
            
            {/* Protected Routes - With sidebar */}
            <Route element={<MainLayout />}>
              <Route path="/:restaurantId/dashboard" element={<Dashboard />} />
              <Route path="/:restaurantId/campaign-creation" element={<CampaignCreation />} />
              <Route path="/:restaurantId/analytics" element={<Analytics />} />
              <Route path="/:restaurantId/campaign-ideas" element={<Navigate to="../dashboard" replace />} />
              <Route path="/:restaurantId/flyer" element={<Playground />} />
              <Route path="/:restaurantId/integrations" element={<Integrations />} />
              <Route path="/:restaurantId/integrations/:integrationName" element={<Integrations />} />
              <Route path="/:restaurantId/demographics" element={<Demographics />} />
              <Route path="/:restaurantId/menu-enhancement" element={<MenuEnhancement />} />
              <Route path="/:restaurantId/marketing-calendar" element={<MarketingCalendar />} />
              <Route path="/:restaurantId/review-analysis" element={<ReviewAnalysis />} />
              <Route path="/:restaurantId/competitor-promotions" element={<CompetitorPromotions />} />
              <Route path="/:restaurantId/competitors" element={<Competitors />} />
              <Route path="/:restaurantId/upcoming-events" element={<UpcomingEvents />} />
              <Route path="/:restaurantId/campaigns" element={<Campaigns />} />
              <Route path="/:restaurantId/campaign-generator" element={<CampaignGenerator />} />
              <Route path="/:restaurantId/menu" element={<Menu />} />
              <Route path="/:restaurantId/post-campaign" element={<PostCampaign />} />
            </Route>
          </Route>
          
          {/* Catch all - redirect based on authentication */}
          <Route path="*" element={
            (() => {
              const restaurantId = localStorage.getItem('restaurantId');
              const accountId = localStorage.getItem('account_id');
              const token = localStorage.getItem('token');
              const isAuthenticated = restaurantId && (accountId || token);
              
              return <Navigate to={isAuthenticated ? "/oops" : "/login"} replace />;
            })()
          } />
        </Routes>
     
    </>
  );
};

export default AppWrapper;
